import { Dispatch, useEffect, useRef } from 'react';
import { AnyAction } from 'redux';
import * as canvasActions from '../actions/canvasBlocks';
import { IBlock } from '../types/content';

type Layout = number[];

interface Args {
    lastBlock: IBlock;
    generateBlock: (layout?: Layout) => IBlock;
    layout?: Layout;
    dispatch: Dispatch<AnyAction>;
}

/**
 * Hook to handle adding a new block to the canvas and scrolling to it
 * when clicking on it
 */
export const useAddBlock = ({ lastBlock, generateBlock, layout, dispatch }: Args) => {
    // Ref with useEffect used to get up-to-date lastBlock in the setTimeout
    const lastBlockRef = useRef(lastBlock);
    useEffect(() => {
        lastBlockRef.current = lastBlock;
    }, [lastBlock]);

    const addBlock = () => {
        const block = generateBlock(layout);
        dispatch(canvasActions.addBlock({ block }));

        // fancy transition to highlight the new block
        setTimeout(() => {
            const newBlock = document.getElementById(lastBlockRef.current.index);
            newBlock && newBlock.scrollIntoView({ behavior: 'smooth' });
        }, 250);
    };
    return addBlock;
};
